import script from "./WeatherEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./WeatherEffect.vue?vue&type=script&setup=true&lang=js"

import "./WeatherEffect.vue?vue&type=style&index=0&id=48ec9fd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ec9fd8"]])

export default __exports__